import { useAuthentication } from '@starjack/features/authentication';
import { useCallback, useState } from 'react';
import { buildSearchParams, urlBuilder } from '@starjack/utils';
import {
    AggregatedTicketSearchParams,
    convertAggregatedTicketSearchParamsToBackend,
} from '../../aggregatedTicket';
import { useNotification } from '@starjack/features/notifications';
import { format } from 'date-fns';

const DATE_TIME_FORMAT = 'dd.MM.yyyy HH:mm';

const downloadContentGeneric = (filename: string, content: string) => {
    const element = document.createElement('a');
    element.setAttribute('href', content);
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
};

export const useExportAggregatedTickets = () => {
    const { jwt } = useAuthentication();
    const [exportLoading, setExportLoading] = useState(false);
    const { addNotification } = useNotification();

    const showErrorDownload = useCallback(() => {
        addNotification({
            type: 'error',
            message:
                'Export fehlgeschlagen. Bitte später noch einmal versuchen.',
        });
    }, [addNotification]);

    const exportTickets = useCallback(
        async (searchParams: AggregatedTicketSearchParams) => {
            setExportLoading(true);
            const url = urlBuilder('order', 'liftoperators/tickets-paged.xlsx');

            const response = await fetch(
                `${url}${buildSearchParams(
                    convertAggregatedTicketSearchParamsToBackend(searchParams)
                )}`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: `bearer ${jwt}`,
                    },
                }
            );

            if (response.ok) {
                const data = await response.blob();

                if (data) {
                    downloadContentGeneric(
                        `Verkaufsreport - ${format(
                            new Date(),
                            DATE_TIME_FORMAT
                        )} .xlsx`,
                        URL.createObjectURL(data)
                    );
                } else {
                    showErrorDownload();
                }
            } else {
                showErrorDownload();
            }

            setExportLoading(false);
        },
        [jwt, showErrorDownload]
    );

    return [exportTickets, { isLoading: exportLoading }] as const;
};
